import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/experimental/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/faq/FaqSearchClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layout/FaqLayout.tsx");
